<template>
    <div>
        <div class="col-sm-12">
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px"
                    >{{ $t('landingPage.settingContact.titleBlock') }} <span class="text-danger">*</span></label
                >
                <div class="col-sm-10">
                    {{ dataForm.block_contact?.title_block ?? '' }}
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.background') }}</label>
                <div class="col-sm-10">
                    <div v-if="dataForm.block_contact.background_image?.path" style="width: 200px; height: 200px" class="position-relative">
                        <b-img
                            class=""
                            thumbnail
                            fluid
                            :src="dataForm.block_contact.background_image?.path"
                            :alt="dataForm.block_contact.background_image.origin_name"
                            style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                        ></b-img>
                    </div>
                    <div class="my-3">
                        <InputText
                            style="max-width: 100px"
                            :model.sync="dataForm.block_contact.background_color"
                            :config="{
                                type: 'color',
                                classCustom: 'form-control-color',
                                error: false
                            }"
                            :disabled="true"
                        />
                    </div>
                    <div>
                        <InputCheckBox
                            :model.sync="dataForm.block_contact.is_repeat"
                            :id="`check-repeat-background-contact`"
                            :value="dataForm.block_contact.is_repeat"
                            :label="`repeat`"
                            :disabled="true"
                        />
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.style') }} </label>
                <div class="col-sm-10">
                    <div style="width: 100px; height: 80px">
                        <img
                            class="w-100 h-100"
                            style="object-fit: cover"
                            :src="dataForm.block_contact.style?.image_preview"
                            :alt="dataForm.block_contact.style?.image_preview"
                        />
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.contactOfficeName') }}</label>
                <div class="col-sm-10">
                    {{ dataForm.block_contact?.contact_secretariat_name ?? '' }}
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.tel') }} </label>
                <div class="col-sm-10">
                    {{ dataForm.block_contact?.tel ?? '' }}
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.mail') }}</label>
                <div class="col-sm-10">
                    {{ dataForm.block_contact?.mail ?? '' }}
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.detail') }} </label>
                <div class="col-sm-10">
                    <div class="body__preview">
                        <div
                            id="contactBlock"
                            class="block__contact"
                            :style="`background-color: ${dataForm.block_contact.background_color ?? ''};
                                background-image: url(${dataForm.block_contact.background_image?.path ?? ''});
                                background-repeat: ${dataForm.block_contact.is_repeat ? 'repeat' : 'no-repeat'};
                                min-height: 300px;`"
                        >
                            <div :class="`box--contact__${dataForm.block_contact.style?.id}`">
                                <h2
                                    v-if="STYLE_SHOW_TITLE.includes(dataForm.block_contact.style?.id)"
                                    class="title-common"
                                    :style="`background: ${dataForm.block_contact.background_title ?? ''};
                                            color:  ${dataForm.block_contact.color_title ?? ''};
                                            font-size: ${dataForm.block_contact.size_title}px;`"
                                >
                                    <span>{{ dataForm.block_contact.title_block }}</span>
                                </h2>
                                <div v-else class="title-common">
                                    <h2
                                        class="title-eng"
                                        :style="`background: ${dataForm.block_contact.background_title ?? ''};
                                                color:  ${dataForm.block_contact.color_title ?? ''};
                                                font-size: ${dataForm.block_contact.size_title}px;`"
                                    >
                                        <span>{{ dataForm.block_contact.title_block }}</span>
                                    </h2>
                                    <!-- <h2 class="title-jp"></h2> -->
                                </div>
                                <div v-html="dataForm.block_contact?.html_content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { InputText, InputCheckBox } from '@/components/Input';
import { STYLE_SHOW_TITLE } from '../../../constants';

export default {
    name: 'SettingContact',
    components: {
        InputText,
        InputCheckBox
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    data() {
        return {
            STYLE_SHOW_TITLE: STYLE_SHOW_TITLE
        };
    },
    methods: {},
    mounted() {}
};
</script>

<style lang="scss" scoped></style>
